
import { Component, Prop, Vue } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import { ValidationProvider } from "vee-validate";
import {
  ISolCustomerDenominationPack,
  ISolCustomerPack,
  ISolCustomerPackQuantity,
} from "@/entities";

@Component({
  name: "packs",
  components: {
    Multiselect,
    ValidationProvider,
  },
})
export default class Packs extends Vue {
  @Prop({ required: true, default: [] })
  packs!: ISolCustomerPack[];
  @Prop({ required: true })
  packQuantities!: ISolCustomerPackQuantity[];

  packsSelected: ISolCustomerPack[] = [];
  collapsed = true;

  get totalAmounts(): { amount: number; currencySymbol: string }[] {
    const amounts: { amount: number; currencySymbol: string }[] = [];
    if (this.packQuantities) {
      this.packQuantities?.forEach((p, index) => {
        if (p.packQuantity) {
          let amountByCurrency = amounts.find(
            (a) => a.currencySymbol === this.currencySymbol(index)
          );

          if (amountByCurrency) {
            amountByCurrency.amount +=
              (p.packQuantity || 0) * this.sumDenominations(this.packs[index].denominations);
          } else {
            amounts.push({
              amount:
                (p.packQuantity || 0) * this.sumDenominations(this.packs[index].denominations),
              currencySymbol: this.currencySymbol(index),
            });
          }
        }
      });
    }
    return amounts;
  }

  get packsQuantitySelected(): ISolCustomerPackQuantity[] {
    const packs: ISolCustomerPackQuantity[] = [];

    this.packsSelected.forEach((p) => {
      const pack = this.packQuantities.find((pq) => pq.packId === p.id)!;
      if (pack.packQuantity === undefined) {
        this.$set(pack, "packQuantity", null);
      }
      packs.push(pack);
    });

    return packs;
  }

  sumDenominations(denominations: ISolCustomerDenominationPack[] | undefined): number {
    let amount = 0;

    denominations?.forEach(
      (denomination) => (amount += (denomination?.quantity || 0) * (denomination?.value || 0))
    );

    return amount;
  }

  currencySymbol(index: number): string {
    if (this.packs && this.packs.length) {
      const denominations = this.packs[index]?.denominations || [];

      return denominations[0]?.currencySymbol || "";
    }
    return "";
  }

  onRemovePackSelected(pack: ISolCustomerPack): void {
    const packQuantity = this.packQuantities.find((p) => p.packId === pack.id);
    packQuantity!.packQuantity = null;
  }
}
